import { Ban } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import { getAppHomePath } from "@/config/path";

import { CustomButton } from "../Button";

export const NoPermissionFallback = () => {
  const { pathname } = useLocation();

  return (
    <div className="flex flex-col items-center justify-center p-8 text-gray-500 h-full w-full min-h-[400px]">
      <Ban className="w-12 h-12 mb-4 text-gray-300" />
      <h2 className="text-xl font-bold text-gray-700 mb-2">Access Denied</h2>
      <p className="text-sm text-center mb-6 max-w-md">
        You don&apos;t have permission to view this page. Please contact your
        administrator.
      </p>
      <CustomButton asChild>
        <Link to={getAppHomePath(pathname)}>Go to Dashboard</Link>
      </CustomButton>
    </div>
  );
};
